import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const getProviderCompletionStats = ( year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/completion/' + year + '?survey_type=' + survey_type;

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getProviderSectionCompletionStats = ( provider_id, academic_year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/year/' + academic_year + '/statistics/completion?survey_type=' + survey_type ;

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getProviderSectionRAGStats = ( provider_id, academic_year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/year/' + academic_year + '/statistics/rag?survey_type=' + survey_type ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderSectionRAGReport = ( provider_id, academic_year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/year/' + academic_year + '/reports/rag' + '?survey_type=' + survey_type;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

//Change this to include survey type
export const getAdminSectionRAGStats = (  academic_year, survey_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/rag/' + academic_year + '?survey_type=' + survey_type;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getAdminSectionQuestionRAGStats = (  academic_year, table_section_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/rag/' + academic_year + '/section/' + table_section_id ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSchoolsWithQuestionStatus = (  academic_year, table_section_id, table_question_id, status, onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/rag/' + academic_year + '/section/' + table_section_id + '/' + table_question_id + '?status=' + status ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

